import timesheetStructuresService from "presentation/services/timesheet-structures";
import timesheetStructureItemsFunctions from 'presentation/pages/timesheet-structures/functions/timesheet-structure-items';
import { goTo } from "presentation/utils/functions/generic";



export const handleSubmit = async (component) => {
    const { form, timesheetStructureItems, rawDaysOfWeek } = component.state;
    component.setState({ loading: true, actionLoading: true, error: '' });
    const {
        name,
    } = form;
    let errors = [];

    if (!name) {
        errors.push("Por favor, preencha um nome para essa estrutura...");
    }

    if (rawDaysOfWeek.length <= 0) {
        errors.push("Por favor, informe ao menos um dia de semana para essa estrutura...");
    }

    let handledItems = timesheetStructureItems;


    let handledItemsSize = handledItems.length;
    if (handledItemsSize > 0) {
        let count = handledItems.filter((item) => item.name === '' || parseInt(item.durationInMinutes) <= 0).length;
        if (count > 0) {
            errors.push("Uma ou mais tempos de atividade não tem nome ou duração...");
        }
    } else {
        errors.push("Você precisa adicionar tempos de atividade pra essa estrutura...");
    }


    if (errors.length > 0) {
        component.setState({ loading: false, error: true, message: errors.join(" <br />") });
    } else {
        let postData = component.state.form;
        postData.daysOfWeek = rawDaysOfWeek.join(',');
        try {
            const response = await timesheetStructuresService.save(postData);
            if (response.error == true) {
                component.setState({
                    loading: false,
                    actionLoading: false,
                    error: true,
                    message: response.message
                });
            } else {
                let promises = timesheetStructureItemsFunctions.prepareItemsRequests(response, handledItems);
                if (!promises) {
                    component.setState({
                        loading: false,
                        actionLoading: false,
                        error: true,
                        message: 'Erro ao tentar criar os tempos de atividade da estrutura de quadro de horários...'
                    });
                } else {
                    await Promise.all(promises);
                    goTo("/estruturas-quadro-de-horarios", component);
                }
            }
        } catch (err) {
            component.setState({
                loading: false,
                actionLoading: false,
                error: true,
                message: err.message
            });
        }
    }
};

const timesheetStructureFunctions = {
    handleSubmit
}

export default timesheetStructureFunctions;